import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Form, Input, Button, Col, Alert, Select } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { setAgent } from "../../redux/auth/auth-slice";
import { getBackgroundAsync } from "../../redux/features/feature-slice";
import { country, getEnv } from "../../utils/globalVars";
import blacklist from "../../utils/blacklist_profile";
import { useAuthGetTokenMutation, useAuthOauthMutation } from "./service/auth-api";
import { saveAgentState } from "../../redux/loadStorage";

const { Option } = Select;

export function LoginPage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { background } = useSelector((state) => state.feature);
  const [authOauth] = useAuthOauthMutation();
  const [authGetToken] = useAuthGetTokenMutation();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [form] = Form.useForm();

  const handleSubmit = async (value) => {
    setIsLoading(true);
    const data = {
      username: value.username,
      password: value.password,
      country: value.country ?? country(),
    };
    authOauth(data)
      .unwrap()
      .then((res) => {
        const dataToken = {
          auth: true,
          fromWeb: true,
          grant_type: "password",
          client_type: "public",
          country: value.country ?? country(),
          ...res,
        };
        authGetToken(dataToken)
          .unwrap()
          .then((res) => {
            console.log("res.profile:", blacklist.includes(res.profile));
            if (blacklist.includes(res.profile)) {
              setIsLoading(false);
              setError("Accès non autorisé");
            } else {
              saveAgentState(res);
              dispatch(setAgent(res));
              history.push("/home");
            }
          })
          .catch((error) => {
            setIsLoading(false);
            setError(error.data.error);
          });
      })
      .catch((error) => {
        setIsLoading(false);
        setError(error.data.error);
      });
  };

  useEffect(() => {
    dispatch(
      getBackgroundAsync({
        application: "Web Agent",
        type: "background",
        country: country(),
      })
    );
  }, [dispatch]);

  return (
    <>
      <div
        className="login-page"
        style={{
          backgroundImage:
            background === "" || background === undefined
              ? `url(assets/img/background-default.png)`
              : `url(https://assets.wizall.com/image/${background})`,
        }}
      >
        <Col
          lg={6}
          xs={16}
          style={{ marginLeft: "auto", marginRight: "200px" }}
        >
          <div className="card">
            <Form
              style={{ margin: "40px" }}
              name="basic"
              form={form}
              // initialValues={{ username: "it.sn", password: "passer2022" }}
              onFinish={handleSubmit}
            >
              <h2>Bienvenue</h2>
              {error && (
                <Alert
                  message={error}
                  type="error"
                  className="alert-error"
                  showIcon
                />
              )}

              {getEnv() === "dev" && (
                <Form.Item
                  name="country"
                  rules={[{ required: true, message: "Champs requis" }]}
                >
                  <Select>
                    <Option value="sn">Sénégal</Option>
                    <Option value="ci">Cote d'ivoire</Option>
                    <Option value="bf">Burkina Faso</Option>
                    <Option value="ml">Mali</Option>
                  </Select>
                </Form.Item>
              )}
              <Form.Item
                name="username"
                rules={[{ required: true, message: "Champs requis" }]}
              >
                <Input
                  className="form-control"
                  prefix={<UserOutlined className="site-form-item-icon" />}
                  placeholder="Login"
                />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[{ required: true, message: "Champs requis" }]}
              >
                <Input.Password
                  className="form-control"
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  placeholder="Mot de passe"
                />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-secondary"
                  loading={isLoading}
                >
                  Connexion
                </Button>
              </Form.Item>
              <span>
                <Link to="/activate">Premiere connexion / </Link>
                <Link to="/activate">Mot de passe oublié</Link>
              </span>
            </Form>
          </div>
        </Col>
      </div>
    </>
  );
}
export default LoginPage;
